export default "__VITE_ASSET__Cgrzs7Yk__"